import { render, staticRenderFns } from "./allocateDialog.vue?vue&type=template&id=21741d24&scoped=true&"
import script from "./allocateDialog.vue?vue&type=script&lang=js&"
export * from "./allocateDialog.vue?vue&type=script&lang=js&"
import style0 from "./allocateDialog.vue?vue&type=style&index=0&id=21741d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21741d24",
  null
  
)

export default component.exports